import { gql } from '@apollo/client';

export const GET_MEMBER = gql`
  query MyQuery($id: ID!) {
    getMember(id: $id) {
      id
      displayName
    }
  }
`;

export const GET_MEMBERS = gql`
  query MyQuery($displayName: String!) {
    getMembers(filter: { displayName: $displayName }) {
      data {
        displayName
        id
      }
    }
  }
`;

export const GET_PROJECTS = gql`
  query MyQuery($status: [ProjectStatus!], $searchQuery: String) {
    getProjects(status: $status, searchQuery: $searchQuery) {
      id
      colorCode
      projectName
      clientName
      projectStatus
      tentativeEndDate
      tentativeStartDate
      projectType
      hypercarePeriod
      createdAt
      createdById
      members {
        id
        hoursPerWeek
        memberStatus
        member {
          id
          displayName
          providerId
        }
        memberRoles {
          id
          projectRole {
            id
            role
          }
        }
        roleEndDate
        roleStartDate
      }
    }
  }
`;

export const CREATE_PROJECT = gql`
  mutation MyMutation(
    $projectName: String!
    $clientName: String!
    $tentativeStartDate: AWSDateTime!
    $tentativeEndDate: AWSDateTime!
    $projectType: String!
    $hypercarePeriod: Int!
    $projectManagerId: ID!
    $hoursPerWeekForPMOrDR: Int!
    $createdById: ID!
  ) {
    createProject(
      input: {
        projectName: $projectName
        clientName: $clientName
        tentativeStartDate: $tentativeStartDate
        tentativeEndDate: $tentativeEndDate
        projectType: $projectType
        hypercarePeriod: $hypercarePeriod
        projectManagerId: $projectManagerId
        hoursPerWeekForPMOrDR: $hoursPerWeekForPMOrDR
        createdById: $createdById
      }
    )
  }
`;

export const EDIT_PROJECT = gql`
  mutation MyMutation(
    $actionUserId: ID!
    $id: ID!
    $projectName: String!
    $clientName: String!
    $tentativeStartDate: AWSDateTime!
    $tentativeEndDate: AWSDateTime!
    $projectType: String!
    $hypercarePeriod: Int!
    $projectManagerId: ID!
    $hoursPerWeekForPMOrDR: Int!
  ) {
    editProject(
      input: {
        actionUserId: $actionUserId
        id: $id
        projectName: $projectName
        clientName: $clientName
        tentativeStartDate: $tentativeStartDate
        tentativeEndDate: $tentativeEndDate
        projectType: $projectType
        hypercarePeriod: $hypercarePeriod
        projectManagerId: $projectManagerId
        hoursPerWeekForPMOrDR: $hoursPerWeekForPMOrDR
      }
    )
  }
`;

export const GET_PROJECT = gql`
  query MyQuery($id: ID!) {
    getProject(id: $id) {
      tentativeStartDate
      tentativeEndDate
      createdById
      members {
        member {
          id
          displayName
          providerId
        }
      }
    }
  }
`;

export const GET_EDITED_PROJECT = gql`
  query MyQuery($id: ID!) {
    getProject(id: $id) {
      projectName
      projectType
      clientName
      tentativeEndDate
      tentativeStartDate
      hypercarePeriod
      members {
        id
        hoursPerWeek
        memberStatus
        member {
          id
          displayName
          providerId
        }
        memberRoles {
          id
          projectRole {
            id
            role
          }
        }
        roleEndDate
        roleStartDate
      }
    }
  }
`;

export const GET_PROJECT_MEMBERS = gql`
  query MyQuery {
    getMembers {
      data {
        displayName
        id
      }
    }
  }
`;
export const GET_SEARCH_MEMBERS = gql`
  query MyQuery($displayName: String!) {
    getMembers(filter: { displayName: $displayName }) {
      data {
        id
        displayName
      }
    }
  }
`;
export const GET_PROJECT_ROLES = gql`
  query MyQuery {
    getProjectRoles {
      role
      displayName
      id
    }
  }
`;

export const GET_PROJECT_MEMBER_ALLOCATION = gql`
  query MyQuery($memberId: ID!, $projectId: ID) {
    getProjectAllocatedHours(memberId: $memberId, projectId: $projectId) {
      project {
        projectName
        colorCode
        id
      }
      id
      hoursPerWeek
    }
  }
`;

export const CREATE_PROJECT_MEMBERS = gql`
  mutation MyMutation(
    $actionUserId: ID!
    $projectId: ID!
    $suggestedAllocations: AWSJSON
    $memberId: ID!
    $projectRolesIds: [ID]!
    $roleEndDate: AWSDateTime!
    $roleStartDate: AWSDateTime!
    $hoursPerWeek: Int!
  ) {
    createProjectMember(
      input: {
        actionUserId: $actionUserId
        projectId: $projectId
        suggestedAllocations: $suggestedAllocations
        memberId: $memberId
        projectRolesIds: $projectRolesIds
        roleEndDate: $roleEndDate
        roleStartDate: $roleStartDate
        hoursPerWeek: $hoursPerWeek
      }
    )
  }
`;

export const DELETE_PROJECT_MEMBER = gql`
  mutation MyMutation($actionUserId: ID!, $id: ID!) {
    deleteProjectMember(actionUserId: $actionUserId, id: $id)
  }
`;

export const EDIT_PROJECT_MEMBERS = gql`
  mutation MyMutation(
    $actionUserId: ID!
    $projectMemberId: ID!
    $suggestedAllocations: AWSJSON
    $hoursPerWeek: Int!
    $memberId: ID!
    $projectRolesIds: [ID]!
    $projectId: ID!
    $roleEndDate: AWSDateTime!
    $roleStartDate: AWSDateTime!
    $memberStatus: MemberApprovalRequestState!
  ) {
    editProjectMember(
      id: $projectMemberId
      input: {
        actionUserId: $actionUserId
        hoursPerWeek: $hoursPerWeek
        suggestedAllocations: $suggestedAllocations
        memberId: $memberId
        projectRolesIds: $projectRolesIds
        projectId: $projectId
        roleEndDate: $roleEndDate
        roleStartDate: $roleStartDate
        memberStatus: $memberStatus
      }
    )
  }
`;

export const EDIT_PROJECT_MEMBER_START_DATE = gql`
  mutation MyMutation(
    $actionUserId: ID!
    $projectMemberId: ID!
    $hoursPerWeek: Int!
    $memberId: ID!
    $memberStatus: MemberApprovalRequestState
    $projectRolesIds: [ID]!
    $projectId: ID!
    $roleEndDate: AWSDateTime!
    $roleStartDate: AWSDateTime!
  ) {
    editProjectMember(
      id: $projectMemberId
      input: {
        actionUserId: $actionUserId
        hoursPerWeek: $hoursPerWeek
        memberId: $memberId
        memberStatus: $memberStatus
        projectRolesIds: $projectRolesIds
        projectId: $projectId
        roleEndDate: $roleEndDate
        roleStartDate: $roleStartDate
      }
    )
  }
`;

export const GET_CHECK_PROJECT_APPROVALS = gql`
  query MyQuery($projectId: ID!) {
    checkApprovalRequest(type: "PROJECT_TIMELINE_CHANGE", projectId: $projectId)
  }
`;

export const GET_CHECK_APPROVALS = gql`
  query MyQuery($type: String!, $projectId: ID!, $memberId: ID!) {
    checkApprovalRequest(
      type: $type
      projectId: $projectId
      memberId: $memberId
    )
  }
`;

export const GET_CHECK_APPROVAL = gql`
  query MyQuery($memberId: ID!) {
    checkApproval(memberId: $memberId)
  }
`;
